module.exports = __webpack_public_path__ + "img/3924.e953f879.jpg";